import { useEffect, useState } from 'react';

const CONSENT_API_POLL_INTERVAL_MS = 100;
const CONSENT_REFRESH_INTERVAL_MS = 1000;
const CONSENT_UPDATE_DELAY_MS = 100;
const CONSENT_STATE_MAP = {
  0: 'U',
  1: 'G',
  2: 'D',
  3: 'G',
  4: 'D',
};

const getConsentData = (windowObj) => {
  try {
    if (windowObj.GDMGetConsent) {
      return windowObj.GDMGetConsent();
    }

    if (windowObj.google_tag_data?.ics) {
      return [
        'ad_storage',
        'analytics_storage',
        'functionality_storage',
        'personalization_storage',
        'security_storage',
        'ad_user_data',
        'ad_personalization',
      ].reduce((accumulator, key) => {
        return {
          ...accumulator,
          [key]:
            CONSENT_STATE_MAP[
              windowObj.google_tag_data.ics.getConsentState(key, {
                containerScopedDefaults: {},
              })
            ] || 'U',
        };
      }, {});
    }
  } catch {
    return null;
  }

  return null;
};

export const useConsentMode = (consent) => {
  const [granted, setGranted] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const consentEvents = Array.isArray(consent) ? consent : [consent];
    let callbackTimeout;
    let pollTimeout;
    let listenerCleanup;
    let attachedListener = false;

    const updateConsent = () => {
      clearTimeout(callbackTimeout);
      callbackTimeout = setTimeout(() => {
        const consentData = getConsentData(window) || {};
        setGranted(
          consentEvents.every((eventName) => consentData[eventName] === 'G')
        );
      }, CONSENT_UPDATE_DELAY_MS);
    };

    const waitForConsentApis = () => {
      if (
        window.GDMGetConsent ||
        window.google_tag_data?.ics ||
        typeof window.GDMAddConsentListener === 'function'
      ) {
        updateConsent();

        if (
          !attachedListener &&
          typeof window.GDMAddConsentListener === 'function'
        ) {
          attachedListener = true;
          listenerCleanup = window.GDMAddConsentListener(updateConsent);
        }

        if (!attachedListener) {
          pollTimeout = setTimeout(
            waitForConsentApis,
            CONSENT_REFRESH_INTERVAL_MS
          );
        }

        return;
      }

      pollTimeout = setTimeout(
        waitForConsentApis,
        CONSENT_API_POLL_INTERVAL_MS
      );
    };

    waitForConsentApis();

    return () => {
      clearTimeout(callbackTimeout);
      clearTimeout(pollTimeout);

      if (typeof listenerCleanup === 'function') {
        listenerCleanup();
      }
    };
  }, [consent]);

  return granted;
};
